import { render, staticRenderFns } from "./BlogCategory.vue?vue&type=template&id=0f5efb00&scoped=true&"
import script from "./BlogCategory.vue?vue&type=script&lang=ts&"
export * from "./BlogCategory.vue?vue&type=script&lang=ts&"
import style0 from "./BlogCategory.vue?vue&type=style&index=0&id=0f5efb00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5efb00",
  null
  
)

export default component.exports